var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen-base',{staticClass:"screen-animations",attrs:{"title":"Animations","sub-title":_vm.subTitle}},[_vm._l((_vm.internalData),function(ref,index){
var date = ref.date;
var activities = ref.activities;
return [_c('screen-animations-day',{key:("activity-" + date + "-" + index),staticClass:"animations-row",attrs:{"data":activities,"date":date}}),_vm._v(" "),(index < 6)?_c('div',{key:("separator-" + date + "-" + index),staticClass:"separator"}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }